import React from "react";

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="tw-flex tw-mt-7 tw-items-center tw-justify-between tw-text-base tw-text-gray-600 dark:tw-text-gray-400 tw-w-[90%] xl:tw-w-10/12 tw-mx-auto">
      {steps?.map((step, index) => (
        <React.Fragment key={index}>
          {+index !== 0 && (
            <div
              className={`tw-h-1 tw-w-full tw-transition-colors tw-duration-200 ${
                currentStep >= index + 1 ? "tw-bg-primary" : "tw-bg-gray-200"
              }`}
            ></div>
          )}
          <div className="tw-flex tw-items-center tw-relative xl:tw-text-[16px] lg:tw-text-[15px] md:tw-text-[13px] tw-text-[11px]">
            <div
              className={`${
                currentStep >= index + 1
                  ? "tw-bg-primary tw-text-white"
                  : "tw-bg-[#E5E4E4] tw-text-secondary"
              } tw-w-7 tw-h-7 xl:tw-w-9 xl:tw-h-9 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-colors tw-duration-200`}
            >
              {index + 1}
            </div>

            <span className="tw-absolute tw-text-secondary tw-top-10 tw-text-center tw-translate tw-left-1/2 -tw-translate-x-1/2 lg:tw-whitespace-nowrap">
              {step.label}
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;
